import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-df6b3870"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-col my-2 text-gray-400" };
const _hoisted_2 = { class: "min-w-4" };
const _hoisted_3 = { class: "p-1" };
import { appState } from '@/composable/appState';
import { ChatWidgetSettingsDataOptions } from '@/helper/const';
import { updateChatWidgetSetting } from '@/helper/helper';
import { LinkExternal01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIFormItem, UISelect, UITextXsRegular } from '@gohighlevel/ghl-ui';
import { inject } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'WhatsappSettings',
    setup(__props) {
        const router = inject('router');
        const formattedOptions = () => {
            var _a;
            return (_a = appState === null || appState === void 0 ? void 0 : appState.waNumbers) === null || _a === void 0 ? void 0 : _a.map(number => ({
                label: `${number.label} - ${number.value}`,
                value: number.value,
            }));
        };
        const handleWhatsappClick = () => {
            router.push({
                name: 'whatsapp-v1',
                params: { location_id: appState.locationId },
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(UIFormItem), {
                        label: _ctx.$t('sidebar.selectWhatsappNumber'),
                        "show-feedback": false,
                        path: "phone"
                    }, {
                        default: _withCtx(() => {
                            var _a, _b;
                            return [
                                _createVNode(_unref(UISelect), {
                                    value: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.waNumber,
                                    id: "select-id",
                                    modelValue: (_b = _unref(appState).chatWidgetSettingsData) === null || _b === void 0 ? void 0 : _b.waNumber,
                                    options: formattedOptions(),
                                    clearable: true,
                                    type: "default",
                                    resetMenuOnOptionsChange: true,
                                    size: "large",
                                    placeholder: "Select one",
                                    "onUpdate:value": _cache[0] || (_cache[0] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).WA_NUMBER, val))
                                }, null, 8 /* PROPS */, ["value", "modelValue", "options"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"])
                ]),
                _createVNode(_unref(UITextXsRegular), null, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.whatsappHelper1')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_unref(UITextXsRegular), { class: "mt-2" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.whatsappHelper2')) + " ", 1 /* TEXT */),
                        _createElementVNode("a", {
                            onClick: handleWhatsappClick,
                            class: "text-primary whatsapp-button"
                        }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.whatsappHelper3')) + " ", 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_unref(LinkExternal01Icon), { class: "w-3 h-3" })
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
